import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackCheckoutClick } from '../utils/pixel';
interface SectionCTAProps {
  /** Transformational promise shown above the button. */
  promise: string;
  label: string;
  tone?: 'light' | 'dark';
}

/**
 * "Botón transformacional" placed at the end of every section: the promise
 * of the transformation plus a direct path to checkout.
 */
export function SectionCTA({
  promise,
  label,
  tone = 'light'
}: SectionCTAProps) {
  const isDark = tone === 'dark';
  return <div className="mt-8 sm:mt-10" data-id="element-71" data-mp="12mlop9dcq1lt">
      <div className={`rounded-3xl border p-4 text-center sm:p-6 ${isDark ? 'border-white/15 bg-white/[0.06]' : 'border-navy/10 bg-white'}`} data-id="element-72" data-mp="12nepzutjjywk">
        <p className={`text-balance font-serif text-[17px] font-bold leading-snug sm:text-xl ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-73" data-mp="snntxopc1bud">
          {promise}
        </p>

        <a href={CHECKOUT_URL} onClick={trackCheckoutClick} className="mt-4 flex w-full items-center justify-center gap-2 rounded-2xl bg-brand px-4 py-4 text-[13.5px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_7px_0_0_#0E4CA8] transition-all duration-150 hover:-translate-y-0.5 hover:bg-brand-dark active:scale-[0.99] sm:text-base" data-id="element-74" data-mp="23ps2c7p6u5rj">
          <span className="text-balance" data-id="element-75" data-mp="1l14zlvuhhsh4">{label}</span>
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-76" data-mp="1g0z5m90qrtvv" />
        </a>

        <p className={`mt-3 flex flex-wrap items-center justify-center gap-1.5 text-[11.5px] font-semibold ${isDark ? 'text-white/60' : 'text-navy/55'}`} data-id="element-77" data-mp="1fz5wmn2noxkp">
          <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-78" data-mp="1ozubfjzvj1yn" />
          Pago único de USD $15 • Garantía de 7 días
        </p>
      </div>
    </div>;
}